
const ReserveResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
  "success": true,
  "gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  "token": "string",
  "busId": "string",
  "price": 0,
  "financial": {
    "price": 0,
    "maxApplicableDiscountPercentage": 0,
    "availablePaymentMethods": [
      "string"
    ],
    "commissionPercentage": 0
  },
  "verId": "string",
  "errorMessage": "string",
  "reserveCode": "string"
};
 

  export default ReserveResponse;
  